/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type system_status_SystemStatusEventsBody = {
    readonly created_at?: string;
    event_description?: string;
    event_name?: string;
    event_type: system_status_SystemStatusEventsBody.event_type;
    readonly finished_at?: string;
    id?: string;
    planned_end?: string;
    planned_start?: string;
    status: system_status_SystemStatusEventsBody.status;
    readonly updated_at?: string;
};
export namespace system_status_SystemStatusEventsBody {
    export enum event_type {
        INCIDENT = 'incident',
        PLANNED_MAINTENANCE = 'planned_maintenance',
    }
    export enum status {
        SCHEDULED = 'scheduled',
        ONGOING = 'ongoing',
        COMPLETED = 'completed',
    }
}

